import { cn } from "@/lib/utils";

interface StaffCardProps {
  email?: string;
  name: string;
  role: string;
  commissionRate?: number;
  availability: string;
  specialties: string[];
  isClockedIn?: boolean;
  clockedInAt?: string | null;
  selectable?: boolean;
  selected?: boolean;
  onSelect?: () => void;
}

export function StaffCard({ email, name, role, commissionRate, availability, specialties, isClockedIn, clockedInAt, selectable, selected, onSelect }: StaffCardProps) {
  const initials = name.split(" ").map(n => n[0]).join("");
  return (
    <div
      onClick={selectable ? onSelect : undefined}
      className={cn(
        "rounded-xl border bg-card p-5 transition-all",
        selectable && "cursor-pointer hover:shadow-card hover:border-primary/30",
        selected && "border-primary ring-2 ring-primary/20"
      )}
    >
      <div className="flex items-center gap-3">
        <div className="flex h-12 w-12 items-center justify-center rounded-full bg-primary/10 text-sm font-semibold text-primary">
          {initials}
        </div>
        <div>
          <h4 className="font-semibold text-card-foreground">{name}</h4>
          <p className="text-sm text-muted-foreground">{role}</p>
          {email && <p className="text-xs text-muted-foreground">{email}</p>}
        </div>
      </div>
      <div className="mt-3 flex flex-wrap gap-1.5">
        {specialties.map(s => (
          <span key={s} className="rounded-full bg-secondary px-2 py-0.5 text-xs font-medium text-secondary-foreground">{s}</span>
        ))}
      </div>
      {typeof isClockedIn === "boolean" && (
        <p className={cn("mt-2 text-xs font-medium", isClockedIn ? "text-emerald-600" : "text-muted-foreground")}>
          {isClockedIn ? `Clocked in${clockedInAt ? ` · ${new Date(clockedInAt).toLocaleTimeString([], { hour: "numeric", minute: "2-digit" })}` : ""}` : "Clocked out"}
        </p>
      )}
      {typeof commissionRate === "number" && (
        <p className="mt-2 text-xs text-muted-foreground">Commission rate: {commissionRate}%</p>
      )}
      <p className="mt-2 text-xs text-muted-foreground">{availability}</p>
    </div>
  );
}
